import React from "react";
import "./css/Shipping.css";
import airHero from "../assets/out.png"; // ضع صورة كبيرة للطائرة أو الشحن البري
import airIcon from "../assets/out.png"; // أيقونة صغيرة

const AirShipping = () => {
  return (
    <div className="air-container">
      {/* ✅ Hero Section */}
      <div className="air-hero">
        <img src={airHero} alt="الشحن البري" className="air-hero-img" />
        <div className="air-hero-overlay">
          <h1>✈️ الشحن البري</h1>
          <p>
            أسرع وأأمن طريقة لنقل البضائع حول العالم مع تغليف احترافي وتتبّع
            لحظي على مدار الساعة.
          </p>
        </div>
      </div>

      {/* ✅ About Air Shipping */}
      <section className="air-about">
        <h2>ما هو الشحن البري؟</h2>
        <p className="txx">
        صّل شحناتك من مصر إلى كل الدول العربية بأمان وكفاءة:  
•⁠  ⁠شحن منتظم إلى: السعودية، الإمارات، الكويت، الأردن، سلطنة عمان  
•⁠  ⁠تغليف يحمي الشحنة بنسبة أمان تصل لـ 100٪  
•⁠  ⁠سرعة في التسليم وضمان سلامة الوصول  
•⁠  ⁠خدمة عملاء متابعة لحظة بلحظة  


مش بس بنشحن، إحنا بنهتم بكل خطوة من لحظة استلام الشحنة لحد وصولها. </p>
      </section>

      {/* ✅ Our Services */}
      <section className="air-services">
        <h2>خدمات الشحن البري لدينا</h2>
        <div className="air-services-grid">
          <div className="air-service-card">
            <img src={airIcon} alt="توصيل سريع" />
            <h3>توصيل سريع</h3>
            <p>نقل البضائع للوجهات الدولية خلال أيام قليلة فقط.</p>
          </div>
          <div className="air-service-card">
            <img src={airIcon} alt="تتبع لحظي" />
            <h3>تتبع لحظي</h3>
            <p>نظام تتبّع متطور يتيح لك متابعة شحنتك في أي وقت.</p>
          </div>
          <div className="air-service-card">
            <img src={airIcon} alt="تغليف احترافي" />
            <h3>تغليف احترافي</h3>
            <p>تغليف آمن وحماية عالية للبضائع القابلة للكسر.</p>
          </div>
          <div className="air-service-card">
            <img src={airIcon} alt="تخليص جمركي" />
            <h3>تخليص جمركي</h3>
            <p>خدمات تخليص جمركي متكاملة لتسهيل عملية الشحن.</p>
          </div>
        </div>
      </section>

      {/* ✅ Why Choose Air Shipping */}
      <section className="air-why">
        <h2>لماذا تختار الشحن البري مع Safety Zone؟</h2>
        <ul>
          <li>أسرع وسيلة لنقل الشحنات الدولية.</li>
          <li>خدمة عملاء على مدار الساعة.</li>
          <li>تأمين كامل على الشحنات عالية القيمة.</li>
          <li>حلول مخصصة للشركات والأفراد.</li>
          <li>أسعار تنافسية مع خدمة ممتازة.</li>
        </ul>
      </section>

      {/* ✅ CTA */}
      <section className="air-cta">
        <h2>تواصل معنا الآن للشحن البري</h2>
        <p>
          اتصل بنا اليوم للحصول على عرض سعر أو استشارة مجانية حول خدمات الشحن
          البري الخاصة بنا.
        </p>
        <a href="tel:+201028510553" className="air-btn">
          📞 اتصل الآن
        </a>
      </section>
    </div>
  );
};

export default AirShipping;
